import { cn } from "@/lib/utils";
import { Field, FieldLabelProps } from "@base-ui/react/field";
import { Slider } from "@base-ui/react/slider";

type LabelVariant = "field" | "native" | "slider" | "legend";
export const formLabelBaseClassName = "font-medium text-start";

interface LabelProps extends FieldLabelProps {
	children: React.ReactNode;
	required?: boolean;
	visible?: boolean;
	className?: string;
	variant?: LabelVariant;
}

const Label: React.FC<LabelProps> = (props) => {
	const { visible, variant = "field", className, ...labelProps } = props;
	const sharedClassName = cn(formLabelBaseClassName, visible === false && "sr-only", className);

	if (variant === "native") {
		return (
			<label {...(labelProps as React.LabelHTMLAttributes<HTMLLabelElement>)} className={sharedClassName}>
				<LabelContents {...props} />
			</label>
		);
	}

	if (variant === "slider") {
		return (
			<Slider.Label {...(labelProps as React.ComponentProps<typeof Slider.Label>)} className={sharedClassName}>
				<LabelContents {...props} />
			</Slider.Label>
		);
	}

	if (variant === "legend") {
		return (
			<legend {...(labelProps as React.HTMLAttributes<HTMLLegendElement>)} className={sharedClassName}>
				<LabelContents {...props} />
			</legend>
		);
	}

	return (
		<Field.Label {...labelProps} className={sharedClassName}>
			<LabelContents {...props} />
		</Field.Label>
	);
};

const LabelContents: React.FC<LabelProps> = (props) => {
	return (
		<>
			{props.children}
			{props.required && <span className="ml-1 text-(--ms-form-el-required-color,var(--ms-color-danger))">*</span>}
		</>
	);
};

export default Label;
